import { combineReducers, Reducer } from "redux";
import { ExtractListSlice } from "../components/LeftPanel/ExtractList/index";
import { FinancialSlice } from "../components/LeftPanel/FinancialYearList/index";
import { ExtractAddSlice } from "../components/LeftPanel/ExtractAdd";
import { NotificationSlice } from "../components/Notification/Index";
import { ErrorAlertSlice } from "../components/ErrorAlert/Index";
import { ProgressSpinnerSlice } from "../components/ProgressSpinner/Index";
import { CreateScheduleSlice } from "../components/RightPanel/SchedulingConfiguration/CreateSchedule/redux";
import { VersioningSlice } from "../components/RightPanel/Versioning/CreateVersion/redux";
import { OutputConfigSlice } from "../components/RightPanel/OutputConfig/redux";
import { PartitionListSlice } from "../components/LeftPanel/Partition/index";
import { AppConfigSlice } from "../components/AppConfig/Redux/Index";
import { OptOutSlice } from "../components/RightPanel/OptOut/redux/Index";
import { BreadcrumbsItemsSlice } from "../components/RightPanel/BreadcrumbsContainer";
import { CodeListViewSlice } from "../components/RightPanel/Results/redux";

export interface IRootState {
  extractState: ReturnType<typeof ExtractListSlice.reducer>;
  yearsState: ReturnType<typeof FinancialSlice.reducer>;
  extractAdd: ReturnType<typeof ExtractAddSlice.reducer>;
  notificationState: ReturnType<typeof NotificationSlice.reducer>;
  errorAlert: ReturnType<typeof ErrorAlertSlice.reducer>;
  progressSpinnerData: ReturnType<typeof ProgressSpinnerSlice.reducer>;
  scheduling: ReturnType<typeof CreateScheduleSlice.reducer>;
  versioning: ReturnType<typeof VersioningSlice.reducer>;
  outputConfig: ReturnType<typeof OutputConfigSlice.reducer>;
  partition: ReturnType<typeof PartitionListSlice.reducer>;
  appConfig: ReturnType<typeof AppConfigSlice.reducer>;
  optOut: ReturnType<typeof OptOutSlice.reducer>;
  breadcrumbsItems: ReturnType<typeof BreadcrumbsItemsSlice.reducer>;
  codeListView: ReturnType<typeof CodeListViewSlice.reducer>;
}

/**
 * Returns the list of reducers
 */
const createRootReducer: () => Reducer<IRootState> = (): Reducer<IRootState> =>
  combineReducers<IRootState>({
    extractState: ExtractListSlice.reducer,
    yearsState: FinancialSlice.reducer,
    extractAdd: ExtractAddSlice.reducer,
    notificationState: NotificationSlice.reducer,
    errorAlert: ErrorAlertSlice.reducer,
    progressSpinnerData: ProgressSpinnerSlice.reducer,
    scheduling: CreateScheduleSlice.reducer,
    versioning: VersioningSlice.reducer,
    outputConfig: OutputConfigSlice.reducer,
    partition: PartitionListSlice.reducer,
    appConfig: AppConfigSlice.reducer,
    optOut: OptOutSlice.reducer,
    breadcrumbsItems: BreadcrumbsItemsSlice.reducer,
    codeListView: CodeListViewSlice.reducer
  });

export default createRootReducer;
